module.exports = __webpack_public_path__ + "static/media/google-analytics.803fa0d1.png";